import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './LandingPage';
import LandingPagePhones from './LandingPagePhones'; // Import the mobile version
import Login from './Login';
const Dashboard = lazy(() => import('./dashboard'));
const Sales = lazy(() => import('./Sales'));
const Store = lazy(() => import('./Store'));
const Selldrugs = lazy(() => import('./selldrugs'));
const GetDrugs = lazy(() => import('./GetDrugs'));
const Contacts = lazy(() => import('./Contacts'));
const AdminDashboard = lazy(() => import('./AdminDashboard'));
const Salesdetails = lazy(() => import('./Salesdetails'));
const Patientappointments = lazy(() => import('./Patientappointments'));
const Statistics = lazy(() => import('./Statistics'));
const Credits = lazy(() => import('./Credits'));
const BirthdayPage = lazy(() => import('./BirthdayPage'));
const DispensedSoldDrugs = lazy(() => import('./DispensedSoldDrugs'));
const TakenFromShelf = lazy(() => import('./TakenFromShelf'));
const DoctorsRoom = lazy(() => import('./DoctorsRoom'));
const DoctorsDashboard = lazy(() => import('./DoctorsDashboard'));
const Cashier = lazy(() => import('./Cashier'));
const AwaitingPayments = lazy(() => import('./AwaitingPayments'));
const LabDashboard2 = lazy(() => import('./LabDashboard2'));
const LabDashboard = lazy(() => import('./LabDashboard'));
const Laboratory = lazy(() => import('./Laboratory'));
const PatientFiles = lazy(() => import('./PatientFiles'));
const PatientFiles2 = lazy(() => import('./PatientFiles2'));
const PatientFiles3 = lazy(() => import('./PatientFiles3'));
const RadiographerDashboard = lazy(() => import('./RadiographerDashboard'));
const Radiology = lazy(() => import('./Radiology'));
const ViewFile = lazy(() => import('./ViewFile'));
const DischargeForm = lazy(() => import('./DischargeForm'));
const ReferralForm = lazy(() => import('./ReferralForm'));
const DrugOrigins = lazy(() => import('./DrugOrigins'));
const GenerateDrugOrder = lazy(() => import('./GenerateDrugOrder'));
const NurseDashboard = lazy(() => import('./NurseDashboard'));
const Investigations = lazy(() => import('./Investigations'));
const Viewfiles = lazy(() => import('./Viewfiles'));
const ClinicRegistration1 = lazy(() => import('./ClinicRegistration1'));
const ClinicRegistration = lazy(() => import('./ClinicRegistration'));

const Performance = lazy(() => import('./Performance'));
const Malariagraph = lazy(() => import('./Malariagraph'));
const Payment = lazy(() => import('./Payment'));
const AboutUs = lazy(() => import('./AboutUs'));
const AboutusPhones = lazy(() => import('./AboutusPhones'));
const SetSurvey = lazy(() => import('./SetSurvey'));
const Triage = lazy(() => import('./Triage'));
const MaternityDashboard = lazy(() => import('./MaternityDashboard'));
const Mothers = lazy(() => import('./Mothers'));
const FamilyPlanningMethods = lazy(() => import('./FamilyPlanningMethods'));
const SuggestionBox = lazy(() => import('./SuggestionBox'));
const SubmitSuggestion = lazy(() => import('./SubmitSuggestion'));
const CreatQRcode = lazy(() => import('./CreatQRcode'));
const CreateReceipt = lazy(() => import('./CreateReceipt'));
const Feedback = lazy(() => import('./Feedback'));
const EmployeeSettings = lazy(() => import('./EmployeeSettings'));
const Pricing = lazy(() => import('./Pricing'));
const PricingPhones = lazy(() => import('./PricingPhones'));
const ResetLifeWalletPassword = lazy(() => import('./ResetLifeWalletPassword'));
const Invoice = lazy(() => import('./Invoice'));
const ManageServices = lazy(() => import('./ManageServices'));
const ManageCategories = lazy(() => import('./ManageCategories'));
const VideoCallPage = lazy(() => import('./VideoCallPage'));
const PaymentNew = lazy(() => import('./PaymentNew'));
const EmployeeBalance = lazy(() => import('./EmployeeBalance'));
const InsertClinics = lazy(() => import('./InsertClinics'));
const StockTracking = lazy(() => import('./StockTracking'));
const DHIS2Clinics = lazy(() => import('./DHIS2Clinics'));
const DHIS2LabTestsManager = lazy(() => import('./DHIS2LabTestsManager'));
const RecentLabResultsDHIS2 = lazy(() => import('./RecentLabResultsDHIS2'));
const MothersDHIS2 = lazy(() => import('./MothersDHIS2'));
const ERegisterReports = lazy(() => import('./ERegisterReports'));
const SetWardsAndBeds = lazy(() => import('./SetWardsAndBeds'));


// Device detection function
const isMobileDevice = () => {
  return (
    (window.innerWidth <= 768) || 
    (navigator.userAgent.match(/Android/i)) ||
    (navigator.userAgent.match(/webOS/i)) ||
    (navigator.userAgent.match(/iPhone/i)) ||
    (navigator.userAgent.match(/iPad/i)) ||
    (navigator.userAgent.match(/iPod/i)) ||
    (navigator.userAgent.match(/BlackBerry/i)) ||
    (navigator.userAgent.match(/Windows Phone/i))
  );
};

// Component to choose the appropriate landing page
const DynamicLandingPage = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };

    // Check on initial load
    handleResize();
    
    // Add event listener for window resize
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <LandingPage /> : <LandingPage />;
};

function App() {
  return (
    <Router>
      <Suspense fallback={<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',fontSize:'18px'}}>Loading...</div>}>
        <Routes>
        {/* Use DynamicLandingPage for the root path */}
        <Route path="/" element={<DynamicLandingPage />} />
        <Route path="/login" element={<Login/>} />
        <Route path="/clinic-registration1" element={<ClinicRegistration1/>} />
        <Route path="/clinic-registration" element={<ClinicRegistration/>} />
        <Route path="/aboutus" element={<AboutUs/>} />
         <Route path="/aboutusphones" element={<AboutusPhones/>} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/sales" element={<Cashier />} />
        <Route path="/salespage" element={<Sales />} />
        <Route path="/store" element={<Store />} />\
            <Route path="/invoices" element={<Invoice />} />
        <Route path="/selldrugs" element={<Selldrugs />} />
        <Route path="/dispensary/shelves" element={<Selldrugs />} />
        <Route path="/remove-drugs" element={<GetDrugs />} />
        <Route path="/contacts/:employee" element={<Contacts />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/employeesettings" element={<EmployeeSettings />} />
        <Route path="/access-sales-details"element={<Salesdetails />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="/birthdays/:employee" element={<BirthdayPage />} />
        <Route path="/patient-appointments" element={<Patientappointments />} />
        <Route path="patient-appointments" element={<Patientappointments />} />
        <Route path="clinicStatistics"element={<Statistics />} />
        <Route path="/credits" element={<Credits />} />
        <Route path="/setsurvey" element={<SetSurvey />} />
        <Route path="birthdays" element={<BirthdayPage />} />
        <Route path="dispensed-and-sold" element={<DispensedSoldDrugs />} />
        <Route path="removed-drugs-equipment" element={<TakenFromShelf />} />
        <Route path="/attend-to-new-patient" element={<Triage />} />
        <Route path="/access-doctors-room" element={<DoctorsDashboard />} />
        <Route path="/cashier" element={<Cashier />} />
        <Route path="/awaitingpayments" element={<AwaitingPayments />} />
        <Route path="/access-laboratory" element={<LabDashboard2 />} />
        <Route path="/labTests" element={<LabDashboard />} />
        <Route path="/labTestsDHIS2" element={<RecentLabResultsDHIS2 />} />
        <Route path="/lab" element={<Laboratory />} />
        <Route path="/patientfiles" element={<PatientFiles />} />
        <Route path="/patientfiles2" element={<PatientFiles2 />} />
        <Route path="/patientfiles-eregister" element={<PatientFiles3 />} />
        
        <Route path="/patient-file/:token/:fileId" element={<ViewFile />} />
        <Route path="/patient-file2/:token/:fileId" element={<Viewfiles />} />
        <Route path="/access-radiographer" element={<RadiographerDashboard/>} />
        <Route path="/radiology" element={<Radiology/>} />
        <Route path="/discharge-form/:token/:fileId" element={<DischargeForm />} />
        <Route path="/referral-form/:token/:fileId" element={<ReferralForm/>} />
        <Route path="/manageDrugs" element={<DrugOrigins/>} />
        <Route path="/makeOrderForDrugs" element={<GenerateDrugOrder/>} />
        <Route path="/access-nurse" element={<NurseDashboard/>} />
        <Route path="/manageLaboratory" element={<Investigations/>} />
        <Route path="/clinic-registration" element={<ClinicRegistration/>} />
        <Route path="/employeePerformance" element={<Performance/>} />
        <Route path="/malariaBarGraph" element={<Malariagraph/>} />
        <Route path="/makePayment" element={<PaymentNew/>} />
        <Route path="/triage" element={<Triage/>} />
        <Route path="/familyPlanning" element={<FamilyPlanningMethods />} />
        <Route path="/maternity-dashboard" element={<MaternityDashboard />} />
       <Route path="/suggestionbox" element={<SuggestionBox />} />
        <Route path="/suggestion-box/:token" element={<CreatQRcode />} />
        <Route path="/rct" element={<CreateReceipt/>} />
        <Route path="/mothers" element={<Mothers />} />
        <Route path="/pricing" element={<Pricing />} />
         <Route path="/pricingphones" element={<PricingPhones />} />
        <Route path="/submitsuggestion/:clinicName" element={<SubmitSuggestion />} />
        <Route path="/submitsuggestion/:clinicName/:token" element={<Feedback />} />
        <Route path="/forgotlifewalletpassword/:token" element={<ResetLifeWalletPassword />} />
        <Route path="/manageServices" element={<ManageServices />} />
         <Route path="/set-sales-expenses-categories" element={<ManageCategories />} />
        <Route path="/videocall/:token" element={<VideoCallPage />} />
         <Route path="/employeebalance" element={<EmployeeBalance/>} />
          <Route path="/insert-clinics" element={<InsertClinics />} />
          <Route path="/stocktracking" element={<StockTracking />} />
          <Route path="/DHIS2Clinics" element={<DHIS2Clinics />} />
          <Route path="/ilovejane" element={<DHIS2LabTestsManager />} />
           <Route path="/mothers-eregister" element={<MothersDHIS2 />} />
<Route path="/eregister-reports" element={<ERegisterReports />} />
<Route path="/setbedsandwards" element={<SetWardsAndBeds/>} />
           
          
        
        
      </Routes>
      </Suspense>
    </Router>
  );
}

export default App;